import React from "react";
import styled from "styled-components";
import { NAVBAR_ITEMS } from "../../config/Constants";
import NavbarItem from "./NavbarItem";
import { useProfileContext } from "../../contexts/ProfileContext";
import { useLoaderContext } from "../../contexts/loaderContext";
// import { useIntercom } from "react-use-intercom";

const Navbar = ({ activePath, onRoute, showBizTripTutorial, hideBizTrip }) => {
  const { profile } = useProfileContext();
  const { loading } = useLoaderContext();
  const isEditBusinessTrip =
    window.location.pathname.includes("edit-business-trip");
  // const { shutdown } = useIntercom();
  return (
    <>
      {loading ? (
        <div style={{ height: "10rem" }}></div>
      ) : (
        <NavbarWrapper>
          {NAVBAR_ITEMS.filter(
            (item, idx) => !(hideBizTrip && item.path === "business"),
          ).map((eachItem, index) => {
            return (
              <NavbarItem
                showBizTripTutorial={showBizTripTutorial}
                key={index}
                labelText={eachItem.label}
                isActive={
                  isEditBusinessTrip && eachItem.path === "business"
                    ? true
                    : activePath === eachItem.path
                }
                handleClick={() => {
                  if (isEditBusinessTrip && eachItem.path === "business") {
                    return;
                  }
                  onRoute(eachItem.path);
                  // shutdown();
                }}
              />
            );
          })}
        </NavbarWrapper>
      )}{" "}
    </>
  );
};

export default Navbar;

const NavbarWrapper = styled.div`
  display: flex;
  gap: 3rem;
`;
